import script from "./OrderJf.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderJf.vue?vue&type=script&setup=true&lang=js"

import "./OrderJf.vue?vue&type=style&index=0&id=75ab4bbf&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75ab4bbf"]])

export default __exports__